export const EMPTY_RICH_TEXT = '<p><br></p>'
